import "antd/es/form/style";
import _Form from "antd/es/form";
var _excluded = ["validateMessageLayout", "extra", "colon", "label"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useLayoutEffect, useState } from 'react';
import { useBrandContext } from '@osui/brand-provider';
import classNames from 'classnames';
import useLabelLayout from './useLabelLayout';
import './index.less';
var clsPrefix = 'osui-form';
var InternalForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$labelAlign;

  var _useBrandContext = useBrandContext(),
      brand = _useBrandContext.brand; // 检测是否有required的内容


  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      hasRequiredItem = _useState2[0],
      setHasRequiredItem = _useState2[1];

  useLayoutEffect(function () {
    var formName = props.name;

    if (formName) {
      var requiredItems = document.querySelectorAll("#".concat(formName, " .ant-form-item-required"));
      setHasRequiredItem(requiredItems.length);
    }
  }, [props.name]);
  var internalLableAlign = (_props$labelAlign = props.labelAlign) !== null && _props$labelAlign !== void 0 ? _props$labelAlign : brand === 'icloud' ? 'left' : 'right';
  return /*#__PURE__*/React.createElement(_Form, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: classNames(clsPrefix, {
      'has-required-item': hasRequiredItem > 0
    }, props.className),
    labelAlign: internalLableAlign
  }));
});

function InternalFormItem(props) {
  var _props$validateMessag = props.validateMessageLayout,
      validateMessageLayout = _props$validateMessag === void 0 ? 'default' : _props$validateMessag,
      extra = props.extra,
      _props$colon = props.colon,
      colon = _props$colon === void 0 ? true : _props$colon,
      label = props.label,
      restProps = _objectWithoutProperties(props, _excluded); // 对extra的样式修改


  var hasHint = !!extra;
  var itemClassName = classNames(restProps.className, "".concat(clsPrefix, "-validate-message-").concat(validateMessageLayout), _defineProperty({}, "".concat(clsPrefix, "-validate-message-has-hint"), hasHint));
  var innerLabel = label && (colon ? /*#__PURE__*/React.createElement(React.Fragment, null, label, "\uFF1A") : label);
  return /*#__PURE__*/React.createElement(_Form.Item, _objectSpread(_objectSpread({}, restProps), {}, {
    className: itemClassName,
    extra: extra,
    colon: false,
    label: innerLabel
  }));
}

var Form = InternalForm;
Form.Item = InternalFormItem;
Form.List = _Form.List;
Form.useForm = _Form.useForm;
Form.Provider = _Form.Provider;
Form.create = _Form.create;
Form.ErrorList = _Form.ErrorList; // osui added

Form.useLabelLayout = useLabelLayout;
export default Form;
//# sourceMappingURL=index.js.map